import classNames from 'classnames';
import map from 'lodash/map';

import LinkToCardItem from 'src/app/components/Elements/Card/LinkToCardItem';
import { orderTracking } from 'src/app/router/paths';
import type { Order as OrderType } from 'src/app/types';

import { getCombinedOrderItemNames } from '../utils';

import styles from './styles.module.scss';

interface OrderProps {
  order: OrderType;
  index: number;
}

export const Order = ({ order, index }: OrderProps) => {
  const itemNames = map(order?.items, 'name');
  const combinedItemNames = getCombinedOrderItemNames(itemNames);

  return (
    <LinkToCardItem
      data-cy={`new-past-order-link-${index}`}
      key={order?.id}
      to={orderTracking.toPath({ orderId: order?.id })}
      aria-label={`Past Order for ${combinedItemNames}`}
    >
      <div className={classNames(styles.orderLink, 'inspectlet-sensitive')}>
        <h3 className={styles.orderItemTitle}>{combinedItemNames}</h3>
        <span className={styles.orderTimeLabel}>{order?.deliveryMethod?.flavorText}</span>
      </div>
    </LinkToCardItem>
  );
};
